import { render, staticRenderFns } from "./ConfigTemplate.vue?vue&type=template&id=3d4dccff&scoped=true"
import script from "./ConfigTemplate.vue?vue&type=script&lang=js"
export * from "./ConfigTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4dccff",
  null
  
)

export default component.exports